export const selectMiscAnalysisList = (state) => state.miscAnalysis.listData;
export const selectIsListInitialized = (state) =>
  state.miscAnalysis.isListInitialized;
export const selectCurrentMiscAnalysis = (state) =>
  state.miscAnalysis.currentMiscAnalysis;
export const selectCurrentMiscAnalysisId = (state) =>
  state?.miscAnalysis?.currentMiscAnalysis?.id;
export const selectCurrentMiscAnalysisName = (state) =>
  state?.miscAnalysis?.currentMiscAnalysis?.name;
export const selectIsCurrentLoading = (state) =>
  state.miscAnalysis.isCurrentLoading;
export const selectCurrentViewTab = (state) =>
  state.miscAnalysis.currentViewTab;
export const selectSelectedRowIndex = (state) =>
  state.miscAnalysis.selectedRowIndex;
export const selectSearchQuery = (state) => state.miscAnalysis.searchQuery;
export const selectSortColumn = (state) => state.miscAnalysis.sortColumn;
export const selectSortOrder = (state) => state.miscAnalysis.sortOrder;
export const selectShowCreatePanel = (state) =>
  state.miscAnalysis.showCreatePanel;
export const selectShowEditPanel = (state) => state.miscAnalysis.showEditPanel;
export const selectEditingMiscAnalysis = (state) =>
  state.miscAnalysis.editingMiscAnalysis;
export const selectIsMiscAnalysisArchived = (state) =>
  Boolean(state?.miscAnalysis?.currentMiscAnalysis?.archivedAt);
